import { render } from "./Dashboard.vue?vue&type=template&id=d00c8564&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"

import "./Dashboard.vue?vue&type=style&index=0&id=d00c8564&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d00c8564"

export default script